import UIPassword from './UIPassword'
export default UIPassword
